import type { IconSvgObject } from './types';

const FrameIcon: IconSvgObject = [
  ["path", { d: "M2 6H22M2 18H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 22L6 2M18 22V2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FrameIcon;
